import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../modules/GeneralFlow/ducks';
import { CacheKey } from '../types';
import { coreClient } from '../utils/request';
import { CountryCode } from '@brenger/api-client';

/**
 * Asks Core whether a guest company is eligible for deferred (reverse-charge) VAT and stores the answer,
 * so getIsExcludingVat can show prices excluding VAT. Unknown (loading, error) stays incl. VAT.
 */
export const useDeferredVatEligibility = (vatNumber: string, countryCode: CountryCode, enabled: boolean): void => {
  const dispatch = useDispatch();
  const { isPending, data } = useQuery({
    queryKey: [CacheKey.DEFERRED_VAT_ELIGIBILITY, vatNumber, countryCode],
    queryFn: () => coreClient.customers.retrieveDeferredVatEligibility({ vatNumber, countryCode }),
    enabled: enabled && !!vatNumber.length,
  });
  const loading = enabled && isPending;
  const eligible = enabled && !!data?.eligible_for_deferred_vat;

  useEffect(() => {
    dispatch(actions.setDeferredVat({ loading, eligible, vat_number: vatNumber, country_code: countryCode }));
  }, [dispatch, loading, eligible, vatNumber, countryCode]);
};
